import DigiobcanApi from '../../api/DigiobcanApi';
import { createQueryFn, QueryNameSpace } from '../../lib/query';
import type { QueryFunctionContext } from '@tanstack/react-query';

type Params = {
  limit?: number;
};

export const meGetNotifications = createQueryFn(
  QueryNameSpace.meGetNotifications,
  async ({
    queryKey,
    pageParam,
  }: QueryFunctionContext<
    [string] | [string, Params],
    string[] | undefined
  >) => {
    const [, params] = queryKey;

    return DigiobcanApi.meGetNotifications({
      ...params,
      pagecursor: pageParam,
    });
  },
);
